import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { CalendarProjectDay } from "src/app/timetracking/models/CalendarCell";

@Component({
  selector: "app-calendar-day-details",
  templateUrl: "./calendar-day-details.component.html",
  styleUrls: ["./calendar-day-details.component.scss"],
})
export class CalendarDayDetailsComponent implements OnInit {
  @Input() projectDay: CalendarProjectDay;
  @HostBinding("class.editable") @Input() canEdit = false;
  @Input() canQuickEdit = false;

  @Output() edit = new EventEmitter();
  @Output() quickEdit = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  editClicked() {
    this.edit.emit();
  }
  quickEditClicked() {
    this.quickEdit.emit();
  }
}
